'use strict'

/**
 * S3 upload orchestrator for master-lot settlement docs.
 *
 * Answers: "how do I ship bytes at the presigned url?"
 *
 * Mirrors PR #1183's `uploadAssayPhotoToS3` shape so the v1 swap is a
 * one-line change: the body becomes a real `fetch` PUT to the presigned
 * URL.
 *
 * Demo body: the bytes have already been parked in IndexedDB by
 * `presignSettlementDoc` (sibling `api.js`); the sentinel `demo://...`
 * URL never resolves to anything network-reachable, so this
 * orchestrator's job in the demo is to validate inputs and let the
 * caller's presign → orchestrator → confirm sequence proceed.
 *
 * V1 body (anchor for the swap):
 *   const r = await fetch(putUrl, {method: 'PUT', headers: {'Content-Type': contentType}, body: file})
 *   if (!r.ok) throw new Error(`S3 upload failed: ${r.status} ${r.statusText}`)
 */

export async function uploadMasterLotSettlementDocToS3({putUrl, file, contentType}) {
  if (!putUrl) throw new Error('putUrl required')
  if (!file) throw new Error('file required')
  if (!contentType) throw new Error('contentType required')
}
